import { DeleteOutlined, MoreOutlined } from "@ant-design/icons";
import { Button, Col, Dropdown, Flex, Modal, Row, Space } from "antd";
import { useForm } from "antd/es/form/Form";
import FormItem from "antd/es/form/FormItem";
import TableAntd from "components/elements/Table";
import { FormInput, FormSelect } from "components/form/FormProvide";
import FormAntd from "components/form/FormProvide/FormAntd";
import { useCallback, useEffect } from "react";
import { useTranslation } from "react-i18next";

const SettingProjectEditRoleModal = ({
    isRoleEditModalOpen,
    onRoleEditModalCancel = () => { },
    employeeOptions = [],
    roleOption = [],
    onSubmitMappingEmployeeRole = () => { },
    initialValues = {},
    employeePaginationByRole = [],
    action = null,
    onPageEmployeeByRoleChange = () => { },
    pagination = {},
    setSearchTxt = () => { },
    onSearchEmployeeByRole = () => { },
    onRemoveEmployeeFromRole = () => { },
    isLoading = false,
    isView = false
}) => {
    const { t, i18n } = useTranslation();

    const [form] = useForm();

    useEffect(() => {
        form.setFieldsValue({ ...initialValues, employeeList: null })
    }, [initialValues, form.getFieldValue("employeeList")])

    const modalConfirmRemoveEmployee = useCallback((params) => {
        return Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: i18n.language === 'en' ? "Are you sure you want to remove this employee from this role?" : "ยืนยันการลบพนักงานนี้ออกจากบทบาทหรือไม่ ",
            onOk() {
                onRemoveEmployeeFromRole({ ...params });
            },
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
        });
    }, [onRemoveEmployeeFromRole])

    const modalSubmitSaveEmployee = useCallback(() => {
        return Modal.confirm({
            title: t("dialog.confirmation.header"),
            content: i18n.language === 'en' ? "Are you sure you want to add employee to this role?" : "ยืนยันการเพิ่มพนักงานเข้าในบทบาทนี้หรือไม่",
            onOk() {
                onSubmitMappingEmployeeRole(form.getFieldsValue(true), form);
                form.setFieldValue("searchTxt", "")
                form.setFieldValue("employeeList", null)
            },
            okText: t("common.confirm"),
            cancelText: t("common.cancel"),
        });
    }, [onSubmitMappingEmployeeRole, form])

    const columns = [
        {
            title: <div className="text-table" style={{ textAlign: "center" }}>{t('common.index')}</div>,
            dataIndex: "index",
            key: "index",
            render: (_, record, idx) => {
                return <span
                    style={{
                        color: "#42526D",
                        backgroundColor: "#F5F6F7",
                        borderRadius: "50%",
                        display: "inline-flex",
                        justifyContent: "center",
                        alignItems: "center",
                        margin: "auto",
                        padding: "8px",
                        minWidth: "30px",
                        height: "30px",
                    }}
                >
                    {/* {idx + 1} */}
                    {((pagination?.current ?? 1) - 1) * (pagination?.pageSize ?? 10) + idx + 1}
                </span>
            },
            width: 90,
            align: "center"
        },
        {
            title: <div className="text-table">{t('employee.label.employee_no')}</div>,
            dataIndex: "employeeNo",
            key: "employeeNo",
            width: 150
        },
        {
            title: <div className="text-table">{t('employee.label.name')}</div>,
            dataIndex: "employeeFullName",
            key: "employeeFullName",
            render: (_, record) => {
                return i18n.language === 'en' ? record?.fullNameEn : record?.fullName
            }
        },
        (action == "EDIT" ? {
            title: "",
            key: "action",
            align: "center",
            width: 90,
            render: (_, record) => (
                <Space size="middle">
                    <Dropdown
                        menu={{
                            items: [
                                !isView && {
                                    key: "1",
                                    onClick: () => modalConfirmRemoveEmployee({ ...record, stpTimeSheetRoleId: form.getFieldValue("stpTimeSheetRoleId") }),
                                    label: `${t("action.delete")}`,
                                    icon: (
                                        <DeleteOutlined style={{ fontSize: "18px", color: "gray" }} />
                                    ),
                                },
                            ],
                        }}
                    >
                        <MoreOutlined style={{ fontSize: "25px", color: "gray" }} />
                    </Dropdown>
                </Space>
            ),
        } : [])
    ]

    return (
        <Modal
            open={isRoleEditModalOpen}
            closable={false}
            maskClosable={false}
            footer={false}
            width={620}
        >
            <Space size={24} direction="vertical" style={{ width: "100%" }}>
                <Flex vertical>
                    <h3>{initialValues?.id ? t("setting_project.label.edit_role") : t("setting_project.label.view_role")}</h3>
                    <span style={{ color: "#667085" }}>{t("setting_project.label.detail_2")}</span>
                </Flex>

                <FormAntd
                    form={form}
                    onFinish={modalSubmitSaveEmployee}
                >
                    <FormItem shouldUpdate>
                        {({ getFieldsValue, getFieldValue, setFieldValue, resetFields }) => {
                            return (
                                <Space direction="vertical" size={16} style={{ width: "100%" }}>
                                    <Col span={12}>
                                        <FormSelect
                                            name="stpTimeSheetRoleId"
                                            label={t("setting_timesheet.label.roleName")}
                                            placeholder={t("common.pleaseSelect")}
                                            size="large"
                                            options={roleOption}
                                            required
                                            disabled
                                        // disabled={action == "VIEW"}
                                        />
                                    </Col>
                                    {
                                        action === "EDIT" ? (
                                            <Row>
                                                <Col span={19}>
                                                    <Flex vertical>
                                                        <h3>{t("setting_project.label.add_member")}</h3>
                                                        <FormSelect
                                                            name="employeeList"
                                                            placeholder={t("common.pleaseSelect")}
                                                            size="large"
                                                            mode="multiple"
                                                            options={employeeOptions}
                                                            disabled={action == "VIEW"}
                                                        />
                                                    </Flex>
                                                </Col>
                                                <Col span={5} style={{ alignContent: "end", textAlignLast: "end" }}>
                                                    <Button
                                                        // onClick={() => setFieldValue("employeeList", [])}
                                                        size="large"
                                                        type="primary"
                                                        htmlType="submit"
                                                        style={{ borderRadius: "8px", backgroundColor: (getFieldValue("employeeList") == null || getFieldValue("employeeList")?.length == 0) ? "" : "var(--button-color)" }}
                                                        disabled={action == "VIEW" || (getFieldValue("employeeList") == null || getFieldValue("employeeList")?.length == 0)}
                                                    >
                                                        {t("employee.label.add")}
                                                    </Button>
                                                </Col>
                                            </Row>
                                        ) : null
                                    }
                                    <Row style={{ gap: "6px" }}>
                                        <Col span={19}>
                                            <FormInput
                                                name="searchTxt"
                                                label={t("common.search_name_empId")}
                                                size="large"
                                                onChange={setSearchTxt}
                                                allowClear
                                            />
                                        </Col>
                                        <Col span={4} style={{ alignContent: "end" }}>
                                            <Button
                                                type="default"
                                                style={{ borderRadius: "8px", height: "40px", color: "#565656", fontWeight: "bold" }}
                                                onClick={() => onSearchEmployeeByRole(form.getFieldsValue(true))
                                                }
                                            >
                                                {t("common.search")}
                                            </Button>
                                        </Col>
                                    </Row>
                                    <TableAntd
                                        loading={isLoading}
                                        columns={columns}
                                        dataSource={employeePaginationByRole}
                                        rowKey={(record) => record?.employeeId}
                                        onChange={onPageEmployeeByRoleChange}
                                        pagination={{
                                            ...pagination,
                                            showTotal: (total, range) =>
                                                t("paginate.description")
                                                    .replace("{min}", range[0])
                                                    .replace("{max}", range[1])
                                                    .replace("{total}", total),
                                        }}
                                    />
                                    <Flex gap={8} justify="end">
                                        <Button
                                            type="default"
                                            style={{ borderRadius: "8px", height: "40px", color: "#565656", fontWeight: "bold" }}
                                            onClick={() => {
                                                onRoleEditModalCancel()
                                                setSearchTxt("")
                                                form.setFieldValue("searchTxt", "")
                                            }}
                                        >
                                            {t("common.cancel")}
                                        </Button>

                                        {/* <Button
                                            type="primary"
                                            htmlType="submit"
                                            style={{ borderRadius: "8px", height: "40px", backgroundColor: "var(--button-color", fontWeight: "bold" }}
                                        >
                                            {t("common.save")}
                                        </Button> */}
                                    </Flex>
                                </Space>
                            )
                        }}

                    </FormItem>

                </FormAntd>
            </Space>
        </Modal>
    )
}

export default SettingProjectEditRoleModal;